<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Perizinan',

    metaInfo: { title: 'Perizinan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'permission',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'permission',
      },
    },
  }
</script>
